import React from 'react'

const Loading: React.FC = () => {
    return <></>
}

export default Loading
